/* eslint-disable no-shadow */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { useIntl } from 'react-intl';
import './ProfilePage.scss';
import {
  getUserDetails,
  uploadLogoFile,
  logoutApi,
  updateLogoInProfileApi,
} from '../../api/profileApi';
import {
  getObjectFromLS,
  clearLocalStorage,
  setStringInLs,
  getValueFromAppConfig,
} from '../../shared/helper-utils/localStorage';
import { NAVIGATION_ROUTES } from '../../shared/constants/Constants';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import ChangePassword from './ChangePassword';
import AppAlert from '../../shared/components/app-alert/AppAlert';
import { isAdminOrAdminStaff } from '../../shared/helper-utils/appUtils';
import {
  APP_AGENT_LOGO_URL,
  APP_USER_PROFILE,
} from '../../saas/AppStorageStaticNames';

function ProfileDetails({ label, value }) {
  return (
    <div className="row mb-2">
      <span className="col-5">{label}</span>
      <span className="col-7">{value}</span>
    </div>
  );
}

function ProfilePage() {
  const intl = useIntl();
  const formattedMessage = (message) => {
    return intl.formatMessage({ id: message });
  };
  const userProfile = getObjectFromLS(APP_USER_PROFILE);
  const [agent, setAgent] = useState({});
  const [alert, setAlert] = useState(undefined);
  const [loading, setLoading] = useState(false);

  const [selectedFile, setSelectedFile] = useState(null);

  // useEffect(() => {
  //   hideHeaderMenu();
  //   return () => showHeaderMenu();
  // }, []);

  const getProfile = async () => {
    setLoading(true);
    const response = await getUserDetails(userProfile?.agentId);
    if (response.ApiStatus.StatusCode === '200') {
      const { User } = response.ApiStatus.Result;
      setAgent(User);
    } else {
      setAlert({
        variant: 'error',
        title: formattedMessage('profile'),
        description: response.ApiStatus?.Message,
      });
    }

    setLoading(false);
  };

  useEffect(() => {
    getProfile();
  }, []);

  // const handleFileUpload = async (event) => {
  //   const file = event.target.files[0];

  //   if (file) {
  //     const allowedTypes = [
  //       'image/jpeg',
  //       'image/jpg',
  //       'image/png',
  //       'application/pdf',
  //     ];

  //     if (!allowedTypes.includes(file.type)) {
  //       setAlert({
  //         variant: 'error',
  //         title: 'Upload',
  //         description: 'Only images and PDFs are allowed.',
  //       });
  //       return;
  //     }

  //     setLoading(true);
  //     const formData = new FormData();
  //     formData.append('file', file);
  //     formData.append('uploadtype', 'logo');
  //     try {
  //       const response = await uploadLogoFile(formData);

  //       if (
  //         response &&
  //         // response.ApiStatus &&
  //         response.status.toLowerCase() === 'ok'
  //       ) {
  //         const uploadedUrl = response.result;
  //         const cacheBustedUrl = `${uploadedUrl}?t=${Date.now()}`;

  //         setSelectedFile(cacheBustedUrl);

  //         setAlert({
  //           variant: 'success',
  //           title: 'Upload Successful',
  //           description: 'Logo updated successfully.',
  //         });

  //         window.location.reload();
  //       } else {
  //         setAlert({
  //           variant: 'error',
  //           title: formattedMessage('file_upload'),
  //           description:
  //             response?.message ||
  //             formattedMessage('document_upload_failure_alert'),
  //         });
  //       }
  //     } catch (error) {
  //       setAlert({
  //         variant: 'error',
  //         title: formattedMessage('file_upload'),
  //         description: formattedMessage('document_upload_failure_alert'),
  //       });
  //     }

  //     setLoading(false);

  //     document.getElementById('upload_file').value = '';
  //   }
  // };

  const handleFileUpload = async (event) => {
    const e = { ...event };
    const file = e.target.files[0];
    if (file) {
      setLoading(true);
      const formData = new FormData();
      formData.append('file', file);
      formData.append('uploadtype', 'agentlogo');
      formData.append('agentid', agent.AgentId);
      const response = await uploadLogoFile(formData);
      if (response) {
        if (response.status === 'OK') {
          const imageUrl = response.result;
          await updateLogoInProfileApi(response.result);
          setStringInLs(APP_AGENT_LOGO_URL, imageUrl);
          setSelectedFile(imageUrl);
          window.location.reload();
        } else {
          setAlert({
            variant: 'error',
            title: formattedMessage('file_upload'),
            description: response.message,
          });
        }
      } else {
        setAlert({
          variant: 'error',
          title: formattedMessage('file_upload'),
          description: formattedMessage('document_upload_failure_alert'),
        });
      }
      setLoading(false);
    }
  };

  const handleLogout = async () => {
    setLoading(true);
    const res = await logoutApi();
    if (res?.ApiStatus.Status === 'OK') {
      setLoading(false);
      window.location.href = NAVIGATION_ROUTES.LOGIN;
      clearLocalStorage();
    }
    setLoading(false);
  };

  const handlePasswordChange = (isFailure, alert) => {
    setAlert(alert);
    if (!isFailure) {
      handleLogout();
    }
  };

  return (
    <section className="profile-page">
      {alert && (
        <AppAlert
          variant={alert.variant}
          showIcon
          title={alert.title}
          description={alert.description}
          onHide={() => setAlert(undefined)}
        />
      )}
      <AppLoading isLoading={loading} />
      {agent && Object.entries(agent).length > 0 && (
        <div className="profile-page__content gap-5">
          <div className="flex-1">
            <div className="profile-page_container">
              <div className="profile-page_container_header">
                {formattedMessage('change_password')}
              </div>
              <div className="profile-page_container_content">
                <ChangePassword onHide={handlePasswordChange} />
              </div>
            </div>
            <div className="profile-page_container">
              <div className="profile-page_container_header">
                {formattedMessage('agency_details')}
              </div>
              <div className="profile-page_container_content">
                <ProfileDetails
                  label={formattedMessage('user_name')}
                  value={`${agent.FirstName} ${agent.LastName}`}
                />
                <ProfileDetails
                  label={formattedMessage('agency')}
                  value={agent.Company}
                />
              </div>
            </div>
            {getValueFromAppConfig('HIDELOGOUPLOAD') !== 'true' &&
              !isAdminOrAdminStaff() && (
                <div className="profile-page_container">
                  <div className="profile-page_container_header">
                    {formattedMessage('logo_upload')}
                  </div>
                  <div className="profile-page_container_content">
                    <p style={{ fontSize: '13px', fontWeight: '500' }}>
                      {formattedMessage('file_selection_size_alert')}
                    </p>
                    <div className="gap-1 d-flex">
                      <div className=" gap-2 mb-2 ">
                        <label
                          htmlFor="upload_file"
                          className="secondary-text required"
                        >
                          {formattedMessage('upload_file')} *
                        </label>
                        <input
                          type="file"
                          accept="image/*"
                          className="file-upload border border-primary mt-2 mb-2"
                          name="upload-file"
                          id="upload_file"
                          onChange={handleFileUpload}
                          style={{ width: '-webkit-fill-available' }}
                        />
                        <span className="secondary-text">
                          {formattedMessage('max_size_allowed_types')}
                        </span>
                        {selectedFile !== '' && selectedFile !== null && (
                          <a
                            style={{ display: 'block', fontSize: 12 }}
                            rel="noopener noreferrer"
                            target="_blank"
                            href={selectedFile}
                          >
                            {formattedMessage('click_here_to_view_upload_file')}
                          </a>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              )}
          </div>
          <div className="flex-1">
            <div className="profile-page_container">
              <div className="profile-page_container_header">
                {formattedMessage('email_address')}
              </div>
              <div className="profile-page_container_content">
                <ProfileDetails
                  label={`${formattedMessage('email_address')}:`}
                  value={agent.ContactEmail}
                />
                <p className="fw-600 mb-0">
                  {formattedMessage('contact_us_to_change_email')}
                </p>
              </div>
            </div>
            <div className="profile-page_container">
              <div className="profile-page_container_header">
                {formattedMessage('phone_numbers')}
              </div>
              <div className="profile-page_container_content">
                <ProfileDetails
                  label={`${formattedMessage('mobile')}:`}
                  value={agent.Gst_phone}
                />
                <ProfileDetails
                  label={`${formattedMessage('agency_phone')}:`}
                  value={agent.MobileNumber}
                />
              </div>
            </div>
            {getValueFromAppConfig('HIDEOTHERDETAILSPROFILE') !== 'true' && (
              <div className="profile-page_container">
                <div className="profile-page_container_header">
                  {formattedMessage('other_details')}
                </div>
                <div className="profile-page_container_content">
                  <ProfileDetails
                    label={formattedMessage('pan_card_no')}
                    value={agent.PanNumber}
                  />
                </div>
              </div>
            )}
            <div className="profile-page_container">
              <div className="profile-page_container_header">
                {formattedMessage('agency_address')}
              </div>
              <div className="profile-page_container_content">
                <ProfileDetails
                  label={`${formattedMessage('address')}:`}
                  value={agent.Address1}
                />
                <ProfileDetails
                  label={`${formattedMessage('city')}:`}
                  value={agent.City}
                />
                <ProfileDetails
                  label={`${formattedMessage('pin')}:`}
                  value={agent.PinCode}
                />
                <ProfileDetails
                  label={`${formattedMessage('state')}:`}
                  value={agent.State}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}

export default ProfilePage;
